import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const allPosts = [
  {
    category: 'Şirket Kuruluş',
    title: 'Şahıs Şirketi mi, Limited Şirket mi? Doğru Seçim Rehberi',
    excerpt: 'İki yapı arasındaki temel farklar, vergi avantajları ve sorumluluk sınırları açısından kapsamlı bir karşılaştırma. Hangi şirket türünün size uygun olduğunu öğrenin.',
    readTime: '6 dk okuma',
    href: '/limited-mi-sahis-mi',
    img: 'https://public.readdy.ai/ai/img_res/a8df180a9e1162845caf29238a762507.jpg',
    tags: ['Şirket Kuruluş', 'Limited Şirket', 'Şahıs Şirketi'],
  },
  {
    category: 'Vergi',
    title: 'Vergi Nasıl Hesaplanır? 2026 Gelir Vergisi Dilimleri',
    excerpt: 'Güncel vergi dilimleri, beyanname süreçleri ve yasal indirimlerle vergi yükünüzü nasıl optimize edebilirsiniz. 2026 yılı güncel rakamlarıyla.',
    readTime: '8 dk okuma',
    href: '/sahis-sirketi-vergi-oranlari',
    img: 'https://readdy.ai/api/search-image?query=financial%20charts%20and%20graphs%20on%20paper%2C%20tax%20documents%2C%20calculator%2C%20professional%20accounting%20workspace%2C%20clean%20white%20background%2C%20soft%20lighting%2C%20business%20finance%20concept%2C%20high%20quality&width=800&height=460&seq=blog002&orientation=landscape',
    tags: ['Vergi', 'Gelir Vergisi', '2026'],
  },
  {
    category: 'E-Fatura',
    title: 'E-Fatura Kimler İçin Zorunlu? 2026 Güncel Bilgiler',
    excerpt: 'E-fatura ve e-arşiv fatura yükümlülükleri, geçiş süreci ve dikkat edilmesi gereken önemli noktalar. 3 milyon TL ciro sınırı ve zorunluluk kapsamı.',
    readTime: '5 dk okuma',
    href: '/e-fatura-kimler-icin-zorunlu',
    img: 'https://readdy.ai/api/search-image?query=digital%20invoice%20on%20laptop%20screen%2C%20modern%20office%20environment%2C%20clean%20desk%2C%20professional%20business%20setting%2C%20soft%20blue%20and%20white%20tones%2C%20technology%20and%20finance%20concept%2C%20high%20quality%20photography&width=800&height=460&seq=blog003&orientation=landscape',
    tags: ['E-Fatura', 'Zorunluluk', 'GİB'],
  },
  {
    category: 'Şirket Kuruluş',
    title: 'Şahıs Şirketi Nasıl Kurulur? Adım Adım 2026 Rehberi',
    excerpt: 'Şahıs şirketi kuruluş süreci, gerekli belgeler, maliyetler ve dikkat edilmesi gereken noktalar. Vergi dairesi kaydından SGK\'ya tüm adımlar.',
    readTime: '7 dk okuma',
    href: '/sahis-sirketi-nasil-kurulur',
    img: 'https://readdy.ai/api/search-image?query=business%20registration%20documents%20and%20official%20papers%20on%20a%20clean%20desk%2C%20stamp%20and%20pen%2C%20professional%20office%20setting%2C%20warm%20natural%20light%2C%20white%20and%20navy%20tones%2C%20high%20quality%20business%20photography&width=800&height=460&seq=blog004&orientation=landscape',
    tags: ['Şahıs Şirketi', 'Kuruluş', 'Belgeler'],
  },
  {
    category: 'Vergi',
    title: 'KDV Nedir? Nasıl Hesaplanır? Oranlar ve İstisnalar',
    excerpt: 'Katma Değer Vergisi\'nin ne olduğu, nasıl hesaplandığı, hangi ürün ve hizmetlerde hangi oranın uygulandığı ve KDV istisnalarına dair kapsamlı rehber.',
    readTime: '6 dk okuma',
    href: '/kdv-nedir-nasil-hesaplanir',
    img: 'https://readdy.ai/api/search-image?query=VAT%20tax%20calculation%20concept%2C%20financial%20documents%20with%20percentage%20symbols%2C%20clean%20professional%20desk%2C%20calculator%20and%20papers%2C%20soft%20warm%20light%2C%20minimal%20white%20background%2C%20business%20accounting%2C%20high%20quality&width=800&height=460&seq=blog005&orientation=landscape',
    tags: ['KDV', 'Vergi', 'Hesaplama'],
  },
  {
    category: 'SGK & Bordro',
    title: 'Bağ-Kur Primi Ne Kadar? 2026 Güncel Tutarlar',
    excerpt: 'Şahıs şirketi sahipleri ve serbest meslek erbabı için Bağ-Kur prim tutarları, ödeme takvimi ve prim basamakları hakkında güncel bilgiler.',
    readTime: '4 dk okuma',
    href: '/bagkur-primi-ne-kadar',
    img: 'https://readdy.ai/api/search-image?query=social%20security%20insurance%20documents%20and%20forms%2C%20professional%20office%20desk%2C%20clean%20minimal%20workspace%2C%20navy%20and%20white%20color%20scheme%2C%20business%20paperwork%20concept%2C%20soft%20natural%20light%2C%20high%20quality%20photography&width=800&height=460&seq=blog006&orientation=landscape',
    tags: ['Bağ-Kur', 'SGK', 'Prim'],
  },
  {
    category: 'Vergi',
    title: 'Vergi Borcu Sorgulama: GİB Üzerinden Nasıl Yapılır?',
    excerpt: 'Gelir İdaresi Başkanlığı portalı üzerinden vergi borcu sorgulama adımları, yapılandırma seçenekleri ve borç ödeme yöntemleri.',
    readTime: '4 dk okuma',
    href: '/vergi-borcu-sorgulama',
    img: 'https://readdy.ai/api/search-image?query=online%20tax%20portal%20on%20computer%20screen%2C%20digital%20government%20services%2C%20clean%20modern%20office%2C%20professional%20workspace%2C%20soft%20blue%20and%20white%20tones%2C%20technology%20and%20finance%2C%20high%20quality%20photography&width=800&height=460&seq=blog007&orientation=landscape',
    tags: ['Vergi Borcu', 'GİB', 'Sorgulama'],
  },
  {
    category: 'Vergi',
    title: 'Vergi Levhası Nasıl Alınır? 2026 Güncel Rehber',
    excerpt: 'Vergi levhası alma işlemi, gerekli belgeler, e-Devlet üzerinden başvuru ve vergi levhası asma zorunluluğu hakkında bilmeniz gerekenler.',
    readTime: '3 dk okuma',
    href: '/vergi-levhasi-nasil-alinir',
    img: 'https://readdy.ai/api/search-image?query=official%20tax%20certificate%20document%20on%20clean%20desk%2C%20government%20paperwork%2C%20professional%20office%20setting%2C%20white%20and%20navy%20tones%2C%20minimal%20background%2C%20business%20compliance%20concept%2C%20high%20quality%20photography&width=800&height=460&seq=blog008&orientation=landscape',
    tags: ['Vergi Levhası', 'e-Devlet', 'Zorunluluk'],
  },
  {
    category: 'Şirket',
    title: 'Şirket Kapatma Nasıl Yapılır? Adım Adım Rehber',
    excerpt: 'Şahıs şirketi ve limited şirket kapatma süreçleri, gerekli belgeler, vergi dairesi ve SGK işlemleri ile tasfiye prosedürleri.',
    readTime: '6 dk okuma',
    href: '/sirket-kapatma-nasil-yapilir',
    img: 'https://readdy.ai/api/search-image?query=business%20closure%20documents%20and%20final%20paperwork%20on%20desk%2C%20professional%20office%20setting%2C%20clean%20minimal%20workspace%2C%20soft%20natural%20light%2C%20navy%20and%20white%20color%20scheme%2C%20corporate%20business%20concept%2C%20high%20quality%20photography&width=800&height=460&seq=blog009&orientation=landscape',
    tags: ['Şirket Kapatma', 'Tasfiye', 'Belgeler'],
  },
  {
    category: 'Muhasebe',
    title: 'Muhasebeci Değiştirme: Süreç ve Dikkat Edilmesi Gerekenler',
    excerpt: 'Mevcut muhasebecinizden ayrılma süreci, devir işlemleri, dikkat edilmesi gereken noktalar ve yeni muhasebeci seçiminde nelere bakılmalı.',
    readTime: '5 dk okuma',
    href: '/muhasebeci-degistirme',
    img: 'https://readdy.ai/api/search-image?query=handshake%20between%20two%20business%20professionals%20in%20modern%20office%2C%20professional%20meeting%2C%20clean%20workspace%2C%20soft%20natural%20light%2C%20navy%20and%20white%20tones%2C%20trust%20and%20partnership%20concept%2C%20high%20quality%20business%20photography&width=800&height=460&seq=blog010&orientation=landscape',
    tags: ['Muhasebeci', 'Değiştirme', 'Devir'],
  },
];

const categories = ['Tümü', 'Şirket Kuruluş', 'Vergi', 'E-Fatura', 'SGK & Bordro', 'Muhasebe', 'Şirket'];

export default function BlogPage() {
  const [activeCategory, setActiveCategory] = useState('Tümü');
  const [search, setSearch] = useState('');

  useEffect(() => {
    window.scrollTo({ top: 0 });
    document.title = 'Blog | Muhasebe, Vergi ve Şirket Kuruluş Rehberleri | Özgür Çakmak SMMM';

    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute('content', content);
    };

    setMeta('description', 'Özgür Çakmak SMMM Blog: Muhasebe, vergi, şirket kuruluş ve mali mevzuat hakkında güncel rehberler. 2026 vergi dilimleri, e-fatura zorunluluğu, Bağ-Kur primleri ve daha fazlası.');
    setMeta('keywords', 'muhasebe blog, vergi rehberi, şirket kuruluş, e-fatura, Özgür Çakmak SMMM, mali müşavir blog');
    setMeta('og:title', 'Blog | Özgür Çakmak SMMM', true);
    setMeta('og:description', 'Muhasebe, vergi ve şirket kuruluş hakkında güncel rehberler. Özgür Çakmak SMMM ile mali süreçlerinizi kolaylaştırın.', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', 'https://ozgurcakmak.com.tr/blog', true);

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) { canonical = document.createElement('link'); canonical.setAttribute('rel', 'canonical'); document.head.appendChild(canonical); }
    canonical.setAttribute('href', 'https://ozgurcakmak.com.tr/blog');
  }, []);

  const filtered = allPosts.filter((p) => {
    const matchCat = activeCategory === 'Tümü' || p.category === activeCategory;
    const matchSearch = search === '' || p.title.toLowerCase().includes(search.toLowerCase()) || p.excerpt.toLowerCase().includes(search.toLowerCase()) || p.tags.some((t) => t.toLowerCase().includes(search.toLowerCase()));
    return matchCat && matchSearch;
  });

  const featured = allPosts[0];

  return (
    <div className="min-h-screen bg-white">
      <BlogNavbar />

      {/* Hero */}
      <section className="relative pt-20 min-h-[380px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=professional%20accounting%20office%20with%20books%20and%20financial%20documents%2C%20clean%20modern%20workspace%2C%20bookshelves%20with%20organized%20files%2C%20soft%20warm%20light%2C%20navy%20and%20white%20color%20scheme%2C%20minimal%20elegant%20interior%2C%20high%20quality%20photography&width=1440&height=500&seq=bloghero1&orientation=landscape&format=webp"
            alt="Özgür Çakmak SMMM Blog"
            className="w-full h-full object-cover object-top"
            loading="eager"
            decoding="async"
          />
          <div className="absolute inset-0 bg-[#0A2540]/50"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 py-16 w-full">
          <nav className="flex items-center gap-2 mb-5" aria-label="breadcrumb">
            <Link to="/" className="text-white/50 text-xs hover:text-white/80 transition-colors">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line text-white/30 text-xs"></i>
            <span className="text-white/70 text-xs">Blog</span>
          </nav>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">Bilgi Merkezi</h1>
          <p className="text-white/70 text-base md:text-lg max-w-xl leading-relaxed">Muhasebe, vergi ve şirket kuruluş hakkında güncel rehberler. Özgür Çakmak SMMM ile mali süreçlerinizi kolaylaştırın.</p>
        </div>
      </section>

      {/* Featured Post */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <span className="text-xs font-semibold tracking-widest text-[#0A2540]/40 uppercase">Öne Çıkan</span>
          <Link to={featured.href} className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-2xl overflow-hidden border border-gray-100 hover:-translate-y-1 transition-all duration-300 group cursor-pointer block">
            <div className="relative h-64 lg:h-auto overflow-hidden">
              <img src={featured.img} alt={featured.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute top-4 left-4">
                <span className="px-3 py-1 bg-white text-[#0A2540] text-xs font-semibold rounded-full">{featured.category}</span>
              </div>
            </div>
            <div className="p-8 lg:p-10 flex flex-col justify-center bg-[#F5F7FA]">
              <div className="flex flex-wrap gap-2 mb-4">
                {featured.tags.map((tag) => (
                  <span key={tag} className="px-2.5 py-1 bg-white border border-gray-200 text-gray-500 text-xs rounded-full">{tag}</span>
                ))}
              </div>
              <h2 className="text-xl md:text-2xl font-bold text-[#0A2540] mb-3 leading-snug">{featured.title}</h2>
              <p className="text-gray-500 text-sm leading-relaxed mb-6">{featured.excerpt}</p>
              <div className="flex items-center justify-between">
                <span className="text-gray-400 text-xs">{featured.readTime}</span>
                <span className="text-[#0A2540] text-sm font-semibold flex items-center gap-1 group-hover:gap-2 transition-all">Devamını Oku <i className="ri-arrow-right-line"></i></span>
              </div>
            </div>
          </Link>
        </div>
      </section>

      {/* Filter & Search */}
      <section className="py-6 bg-white border-b border-gray-100 sticky top-16 md:top-20 z-30">
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
          <div className="flex flex-wrap gap-2">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${activeCategory === cat ? 'bg-[#0A2540] text-white' : 'bg-[#F5F7FA] text-gray-600 hover:bg-gray-200'}`}
              >
                {cat}
              </button>
            ))}
          </div>
          <div className="relative w-full sm:w-64">
            <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-gray-400">
              <i className="ri-search-line text-sm"></i>
            </div>
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Yazı ara..."
              className="w-full pl-9 pr-4 py-2 bg-[#F5F7FA] border border-gray-200 rounded-full text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-[#0A2540]/30 transition-colors"
            />
          </div>
        </div>
      </section>

      {/* Posts Grid */}
      <section className="py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          {filtered.length === 0 ? (
            <div className="text-center py-20">
              <div className="w-16 h-16 flex items-center justify-center bg-[#F5F7FA] rounded-2xl mx-auto mb-4">
                <i className="ri-search-line text-2xl text-gray-400"></i>
              </div>
              <p className="text-gray-500 text-sm">Arama kriterlerinize uygun yazı bulunamadı.</p>
              <button onClick={() => { setSearch(''); setActiveCategory('Tümü'); }} className="mt-4 text-[#0A2540] text-sm font-medium cursor-pointer hover:underline">Filtreleri Temizle</button>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map((post) => (
                <Link
                  key={post.href}
                  to={post.href}
                  className="bg-white border border-gray-100 rounded-2xl overflow-hidden hover:-translate-y-1 transition-all duration-300 group cursor-pointer block"
                >
                  <div className="relative overflow-hidden h-48">
                    <img src={post.img} alt={post.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 bg-white text-[#0A2540] text-xs font-semibold rounded-full">{post.category}</span>
                    </div>
                  </div>
                  <div className="p-5">
                    <div className="flex flex-wrap gap-1.5 mb-3">
                      {post.tags.slice(0, 2).map((tag) => (
                        <span key={tag} className="px-2 py-0.5 bg-[#F5F7FA] text-gray-500 text-xs rounded-full">{tag}</span>
                      ))}
                    </div>
                    <h3 className="text-[#0A2540] font-semibold text-sm leading-snug mb-2 line-clamp-2">{post.title}</h3>
                    <p className="text-gray-500 text-xs leading-relaxed mb-4 line-clamp-3">{post.excerpt}</p>
                    <div className="flex items-center justify-between">
                      <span className="text-gray-400 text-xs">{post.readTime}</span>
                      <span className="text-[#0A2540] text-xs font-medium flex items-center gap-1 group-hover:gap-2 transition-all">Oku <i className="ri-arrow-right-line text-xs"></i></span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#0A2540]">
        <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
          <span className="text-xs font-semibold tracking-widest text-white/40 uppercase">Özgür Çakmak SMMM</span>
          <h2 className="text-2xl md:text-3xl font-bold text-white mt-3 mb-4">Durumunuza Özel Danışmanlık Alın</h2>
          <p className="text-white/60 text-sm leading-relaxed mb-8">Okuduklarınız hakkında sorularınız mı var? Uzman ekibimiz size özel bilgi vermekten memnuniyet duyar.</p>
          <div className="flex flex-wrap gap-3 justify-center">
            <Link to="/" className="px-6 py-3 bg-white text-[#0A2540] text-sm font-semibold rounded-xl hover:-translate-y-0.5 transition-all cursor-pointer whitespace-nowrap">Ana Sayfaya Dön</Link>
            <a href="https://wa.me/905300953230" target="_blank" rel="nofollow noreferrer" className="px-6 py-3 bg-[#25D366] text-white text-sm font-semibold rounded-xl hover:-translate-y-0.5 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"><i className="ri-whatsapp-line"></i>WhatsApp</a>
          </div>
        </div>
      </section>

      <BlogFooter />
      <a href="https://wa.me/905300953230" target="_blank" rel="nofollow noreferrer" className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center bg-[#25D366] text-white rounded-full cursor-pointer hover:scale-110 transition-transform" aria-label="WhatsApp"><i className="ri-whatsapp-line text-2xl"></i></a>
    </div>
  );
}

function BlogNavbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0A2540]/50 backdrop-blur-md border-b border-white/10' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://storage.readdy-site.link/project_files/20f355b3-57c6-42af-8f1b-e19ef75cee72/a013bf3f-953f-4147-a966-2d3225ff6ac1_zgr-akmak-logo-3.png?v=001ea3c7f21fa91e8ebb91c8becb8de9"
            alt="Özgür Çakmak SMMM Logo"
            className="h-12 w-auto object-contain"
          />
        </Link>
        <div className="flex items-center gap-3">
          <Link to="/" className="text-sm font-medium text-white/90 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Ana Sayfa</Link>
          <Link to="/blog" className="text-sm font-medium text-white font-semibold whitespace-nowrap cursor-pointer border-b border-white/50">Blog</Link>
          <a href="https://wa.me/905300953230" target="_blank" rel="nofollow noreferrer" className="px-5 py-2 bg-[#0A2540] text-white text-sm font-medium rounded-lg hover:-translate-y-0.5 transition-all whitespace-nowrap cursor-pointer">İletişime Geç</a>
        </div>
      </div>
    </header>
  );
}

function BlogFooter() {
  const links = [
    { label: 'Şahıs Şirketi Nasıl Kurulur?', href: '/sahis-sirketi-nasil-kurulur' },
    { label: 'Vergi Oranları 2026', href: '/sahis-sirketi-vergi-oranlari' },
    { label: 'Limited mi Şahıs mı?', href: '/limited-mi-sahis-mi' },
    { label: 'E-Fatura Zorunluluğu', href: '/e-fatura-kimler-icin-zorunlu' },
    { label: 'KDV Nedir?', href: '/kdv-nedir-nasil-hesaplanir' },
    { label: 'Vergi Borcu Sorgulama', href: '/vergi-borcu-sorgulama' },
  ];
  return (
    <footer className="bg-[#F5F7FA] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center bg-[#0A2540] rounded-lg">
                <i className="ri-bar-chart-box-line text-white text-base"></i>
              </div>
              <span className="font-bold text-[#0A2540] text-base">Özgür Çakmak SMMM</span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed">Mali süreçlerinizde güvenilir danışmanlık.</p>
          </div>
          <div>
            <h4 className="text-[#0A2540] font-semibold text-sm mb-3">Bilgi Merkezi</h4>
            <ul className="space-y-2">
              {links.map((l) => (
                <li key={l.href}><Link to={l.href} className="text-gray-500 text-xs hover:text-[#0A2540] transition-colors cursor-pointer">{l.label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-[#0A2540] font-semibold text-sm mb-3">İletişim</h4>
            <div className="space-y-2">
              {[{ icon: 'ri-phone-line', text: '0 530 095 32 30' }, { icon: 'ri-mail-line', text: 'info@ozgurcakmak.com.tr' }].map((item) => (
                <div key={item.text} className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center text-gray-400"><i className={`${item.icon} text-sm`}></i></div>
                  <span className="text-gray-500 text-sm">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-gray-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-gray-400 text-xs">© 2026 Özgür Çakmak SMMM. Tüm hakları saklıdır.</p>
          <Link to="/" className="text-gray-400 text-xs hover:text-gray-600 transition-colors cursor-pointer">Ana Sayfaya Dön</Link>
        </div>
      </div>
    </footer>
  );
}
